import React from 'react';
import { OfficeId } from '../../../models/Types';
import { HRAbsenceProposalPage } from './HRAbsenceProposalPage';
import { DefaultSearchParameterItem } from '../../../components/Filter/types';

interface HRAbsenceOpenProposalPageProps {
  className?: string;
  officeId?: OfficeId;
}

export const HRAbsenceOpenProposalPage: React.FC<
  HRAbsenceOpenProposalPageProps
> = ({ className, officeId }) => {
  const customDefaultSearchParameters: DefaultSearchParameterItem[] = [
    {
      parameterName: 'AbsenceState',
      defaultValue: ['requested', 'revokeRequested'],
      defaultMethod: 'eq',
    },
    ...(officeId
      ? [
          {
            parameterName: 'OfficeId',
            defaultValue: officeId,
            defaultMethod: 'eq',
          },
        ]
      : []),
    {
      parameterName: 'EmployeeIsArchived',
      defaultValue: 'false',
      defaultMethod: 'eq',
    },
  ];

  return (
    <HRAbsenceProposalPage
      className={className}
      officeId={officeId}
      customDefaultSearchParameters={customDefaultSearchParameters}
      ignoreBackendDefaultSearchParameters={true}
    />
  );
};

export default HRAbsenceOpenProposalPage;
